<template>
    <div class="service-card" v-on:click="onCardClick(service)">
        <img class="service-image" :src="service.fields.cardImage.fields.file.url">
        <div class="title"><p>{{service.fields.title}}</p></div>
        <div class="bottom-bar"><p>Saiba mais</p></div>
    </div>
</template>

<script>
    export default {
        name: "ServiceCard",
        props: ['service'],
        methods: {
            onCardClick(service) {
                this.$emit('card-selection', service)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .service-card {
        margin-bottom: 1em;
        height: 12em;
        background-color: $bgcolor-grey;
        position: relative;
        overflow: hidden;

        &:hover {
            cursor: pointer;
        }

        .title {
            position: absolute;
            width: 100%;
            bottom: 2em;
            z-index: 2;
            height: 12em;
            max-height: 80%;

            &:hover {
                cursor: pointer;
            }
            p {
                cursor: default;
                font-weight: 500;
                font-size: 1em;
                text-transform: uppercase;
                text-align: center;
                color: $bgcolor-grey;

                margin: 0;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                margin-block-start: 0em;
                margin-block-end: 0em;

                &:hover {
                    cursor: pointer;
                }
            }
        }

        .bottom-bar {
            height: 2em;
            width: 100%;
            position: absolute;
            bottom: 0;
            z-index: 2;
            background-color: $primary;

            &:hover {
                cursor: pointer;
            }

            p {
                cursor: default;
                font-weight: 600;
                font-size: 0.7em;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: $bgcolor-grey;

                margin: 0;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                margin-block-start: 0em;
                margin-block-end: 0em;

                &:hover {
                    cursor: pointer;
                }
            }
        }

        .service-image {
            height: 100%;
            width: 100%;
            position: relative;
            z-index: 1;

            object-position: center;
            object-fit: cover;

            filter: brightness(60%);

            &:hover {
                cursor: pointer;
                filter: brightness(100%);
            }
        }


        &:hover {
            .bottom-bar {
                background-color: $bgcolor-grey;
                p {
                    color: $primary;
                }
            }
            .service-image {
                filter: brightness(100%);
            }
        }
    }

    @media only screen and (max-width: 1024px) {

        .service-card {
            height: 16em;
        }
    }
</style>
